export const baggageRecheckList = [
  {
    title: 'transfer_details.baggage_recheck.first_item.title',
    description: 'transfer_details.baggage_recheck.first_item.description',
  },
  {
    title: 'transfer_details.baggage_recheck.second_item.title',
    description: 'transfer_details.baggage_recheck.second_item.description',
  },
  {
    title: 'transfer_details.baggage_recheck.third_item.title',
    description: 'transfer_details.baggage_recheck.third_item.description',
  },
]
